module.exports = __webpack_public_path__ + "assets/img/img271.2fcd02ad.png";